/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPositiveS = (props: Props) => (
  <Icon viewBox="0 0 22 22" {...props}>
    <g fill="none">
      <path
        d="M22 11 11 0 0 11l11 11 11-11zm-6 1h-4v4h-2v-4H6v-2h4V6h2v4h4v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPositiveS as PositiveS };
